import React from 'react';

export function Line({ styles }) {
  return (
    <div
      style={{
        ...styles.position,
        background: 'red',
        pointerEvents: 'none',
      }}
    />
  );
}
